export function initAccordion() {
  const accordions = document.querySelectorAll('[data-accordion]');
  if (!accordions.length) return;

  accordions.forEach(acc => {
    const defaultTriggers = acc.querySelectorAll('.cmp-accordion__trigger[data-expanded-default="true"]');
    defaultTriggers.forEach(btn => {
      togglePanel(btn, true);
    });

    acc.addEventListener('click', e => {
      const btn = e.target.closest('.cmp-accordion__trigger');
      if (!btn || !acc.contains(btn)) return;

      const expanded = btn.getAttribute('aria-expanded') === 'true';
      togglePanel(btn, !expanded);
    });
  });
}

function togglePanel(btn, expand) {
  const panelId = btn.getAttribute('aria-controls');
  if (!panelId) return;
  const panel = document.getElementById(panelId);
  if (!panel) return;

  btn.setAttribute('aria-expanded', expand.toString());
  panel.hidden = !expand;

  const indicatorImg = btn.querySelector('.cmp-accordion__indicator-img');
  if (indicatorImg) {
    indicatorImg.src = expand ? '/images/minus-sign.svg' : '/images/plus-sign.svg';
    indicatorImg.alt = expand ? 'Collapse section' : 'Expand section';
  }
}
